module.exports = ".pie-1 {\n  min-width: 600px;\n  height: 100%; }\n"